import React from 'react'
import {
  makeStyles, Stepper, StepLabel, Grid, Step,
} from '@material-ui/core'

// import { Route, Routes } from 'react-router-dom'
import RolesStep from './RolesStep'
import TablesStep from './TablesStep'

const steps = {
  [RolesStep.name]: {
    index: 1,
    label: ' انتخاب رویداد',
    component: RolesStep,
  },
  [TablesStep.name]: {
    index: 0,
    label: 'ارسال اثر',
    component: TablesStep,
  },
}

const useStyle = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1.5),
    '& .MuiStepIcon-active': {
      color: 'orange',
    },
    '& .MuiStepIcon-completed': {
      color: 'orange',
    },
  },
}))

export const User = () => {
  const classes = useStyle()
  const [activeStep, setActiveStep] = React.useState(steps[TablesStep.name])
  const CurrentComponent = activeStep.component

  return (
    <>
      <Grid classes={{ root: classes.root }}>
        <Stepper activeStep={activeStep.index} alternativeLabel>
          {Object.values(steps).map((step, index) => {
            return (
              <Step key={index}>
                <StepLabel>{step.label}</StepLabel>
              </Step>
            )
          })}
        </Stepper>
        <CurrentComponent setActiveStep={setActiveStep} steps={steps} />
      </Grid>
      {/* <Routes>
        <Route path="/users" element={<RolesStep />} />
      </Routes> */}
    </>
  )
}

export default User
